import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Footer from '../../../common/footer/Footer'
import { Add_Shipping_Address } from '../../../../api/category_product/Category_Product'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import PhoneInput, {
    parsePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Loader from '../../../../loader/Loader'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { isAlphabetical } from '../../../validation/Validation'
import { countries } from '../../../../utils/countries'
import { Country, State, City } from 'country-state-city';

const User_dashbaord_Add_New_Address = () => {
    // <------------- state of the add new address form --------------->
    const navigate = useNavigate();
    const [is_loading, set_Is_Loading] = useState(false)
    const [mobileNumber, setMobileNumber] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+91");
    const [countryCode, setCountryCode] = useState("IN");
    const [isValid, setIsValid] = useState(false);
    const [errors, setErrors] = useState({});

    const [add_new_address_form_data, set_Add_New_Address_Form_Data] = useState({
        name: "",
        house_name: "",
        landmark: "",
        address: "",
        city: "",
        state: "",
        country: "",
        pin_code: "",
        address_type: "",
    })
    console.log("add_new_address_form_data", add_new_address_form_data);
    // <----------- Onchnage Events on the Phone Input section's -------------->
    const handlePhoneChange = (value) => {

        if (!value || !value.startsWith("+")) {
            setPhoneNumber("+91");
            setCountryCode("91");
            setMobileNumber("");
            return;
        }


        setPhoneNumber(value);

        try {
            const parsedPhone = parsePhoneNumber(value);
            setCountryCode(parsedPhone.countryCallingCode);
            setMobileNumber(parsedPhone.nationalNumber);
        } catch (error) {
            setMobileNumber("");
        }
    };

    // <----------- Handle Key Down Events on the Phone Input section's -------------->
    const handleKeyDown = (e) => {
        // Prevent deleting the "+" or the country code
        if (
            (e.key === "Backspace" || e.key === "Delete") &&
            phoneNumber &&
            phoneNumber.length <= 3 // block when cursor is within "+91"
        ) {
            e.preventDefault();
        }
    };

    // <-------- change the input feilds ----------->
    const Handle_add_new_address = (e) => {
        const newErrors = {};
        setErrors({});
        const { name, value } = e.target;
        if (name === 'name' && value.length && !isAlphabetical(value)) {
            newErrors[name] = "Name should contain only alphabetical characters.";
            setErrors(newErrors);
            return;

        }
        if (name === 'pin_code' && value.length > 6) {
            newErrors[name] = "Pin code should be a valid 6-digit number.";
            setErrors(newErrors);
            return;
        }
        
        if (name === 'country') {
            set_Add_New_Address_Form_Data(prev => ({ ...prev, country: value, state: "", city: "" }));
        } else if (name === 'state') {
            set_Add_New_Address_Form_Data(prev => ({ ...prev, state: value, city: "" }));
        } else {
            set_Add_New_Address_Form_Data(prev => ({ ...prev, [name]: value }));
        }
    }

    // <-------- Apply for the Phone Number Validtion According to the Country and Country code here ----------->
    useEffect(() => {
        setIsValid(isValidPhoneNumber(phoneNumber));
    }, [phoneNumber]);

    // <---------- Submit the Address details ------>
    const Submit_address_details = async (e) => {
        e.preventDefault();
        set_Is_Loading(true)
        const data = {
            name: add_new_address_form_data.name,
            house_name: add_new_address_form_data.house_name,
            landmark: add_new_address_form_data.landmark,
            address: add_new_address_form_data.address,
            phone_number: mobileNumber,
            country_code: `+${countryCode}`,
            city: add_new_address_form_data.city,
            state: add_new_address_form_data.state,
            country: add_new_address_form_data.country,
            pin_code: add_new_address_form_data.pin_code,
            address_type: add_new_address_form_data.address_type,
        }
        if (!isValid) {
            toast("Please enter a valid phone number containing only numbers.");
            set_Is_Loading(false)
            return;
        }
        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            const response = await Add_Shipping_Address(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Is_Loading(false)
                set_Add_New_Address_Form_Data({})
                toast("Shipping address added successfully")

                navigate(-1)
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
                toast.error(response?.response?.data?.message);

            }
            else if (response?.response?.data?.status == "400") {
                toast.error(response?.response?.data?.message);
                set_Is_Loading(false)
            }
        } catch (error) {
            set_Is_Loading(false)
            console.error(error)
        }
    }

    const selectedCountryObj = Country.getAllCountries().find(c => c.name === add_new_address_form_data?.country);
    const stateOptions = selectedCountryObj ? State.getStatesOfCountry(selectedCountryObj.isoCode) : [];
    const selectedStateObj = stateOptions.find(s => s.name === add_new_address_form_data?.state);
    const cityOptions = selectedCountryObj && selectedStateObj ? City.getCitiesOfState(selectedCountryObj.isoCode, selectedStateObj.isoCode) : [];
    
    return (
        <div>
            {/* <------------ Header ------------> */}
            <Header />
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <div className="bg-[#f8f8f8] py-8">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="myaccount-section w-full">
                                    <div className="w-full">
                                        <div className="w-full my-10">
                                            <div className="w-full bg-white shadow-xl p-5">
                                                <div className=" w-full">
                                                    <h1 className="font-bold text-gray-800 mb-4">Add New Address
                                                    </h1>
                                                    <form method='post' onSubmit={Submit_address_details}>
                                                        <div className="flex space-x-8">
                                                            <div className="w-full">
                                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">Name: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <input placeholder="" onChange={Handle_add_new_address} value={add_new_address_form_data?.name} name='name'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                    type="text" required />
                                                                            </div>
                                                                            {errors.name && (
                                                                                <span className="text-red-500 text-sm">{errors.name}</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">House/Flat/Office/Block Name: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <input placeholder="" onChange={Handle_add_new_address} value={add_new_address_form_data?.house_name} name='house_name'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                    type="text" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">Address: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <input placeholder="" onChange={Handle_add_new_address} value={add_new_address_form_data?.address} name='address'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                    type="text" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">Phone: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <PhoneInput
                                                                                    international
                                                                                    defaultCountry="IN"
                                                                                    value={phoneNumber}
                                                                                    onChange={handlePhoneChange}
                                                                                    onKeyDown={handleKeyDown}
                                                                                    maxLength={15}
                                                                                    className="w-full px-4 bg-white text-sm text-gray-700 outline-none focus:ring-2 focus:ring-red-400 h-[40px]"
                                                                                    placeholder="Enter phone number"
                                                                                    required
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">Country: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <select onChange={Handle_add_new_address} value={add_new_address_form_data?.country} name='country'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px] appearance-none" required>
                                                                                    <option value="" disabled>Select Country</option>
                                                                                    {countries.map((country, idx) => (
                                                                                        <option key={idx} value={country}>{country}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">State / Province: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <select onChange={Handle_add_new_address} value={add_new_address_form_data?.state} name='state'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px] appearance-none" required>
                                                                                    <option value="" disabled>Select State</option>
                                                                                    {stateOptions.map((state, idx) => (
                                                                                        <option key={idx} value={state.name}>{state.name}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">City: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <select onChange={Handle_add_new_address} value={add_new_address_form_data?.city} name='city'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px] appearance-none" required>
                                                                                    <option value="" disabled>Select City</option>
                                                                                    {cityOptions.map((city, idx) => (
                                                                                        <option key={idx} value={city.name}>{city.name}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="w-1/2 h-full">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">PinCode: *</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <input placeholder="" onChange={Handle_add_new_address} value={add_new_address_form_data?.pin_code} name='pin_code'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                    type="number" required />
                                                                            </div>
                                                                            {errors.pin_code && (
                                                                                <span className="text-red-500 text-sm">{errors.pin_code}</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                                    <div className="w-1/2 h-full mb-4">
                                                                        <div className="input-com "><label
                                                                            className="input-label text-[13px] font-medium">Landmark:</label>
                                                                            <div
                                                                                className="input-wrapper border border-gray-200  overflow-hidden relative ">
                                                                                <input placeholder="" onChange={Handle_add_new_address} value={add_new_address_form_data?.landmark} name='landmark'
                                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                    type="text" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="w-1/2 h-full mb-4">
                                                                        <label
                                                                            className="input-label text-[13px] font-medium">Address Type:</label>
                                                                        <div
                                                                            className="input-wrapper overflow-hidden relative flex items-center ">
                                                                            <input placeholder="" onChange={Handle_add_new_address} value="Home" name='address_type'
                                                                                className="input-field placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                type="radio" required checked={add_new_address_form_data?.address_type === "Home"} /><span className='ml-2'>Home</span>
                                                                            <input placeholder="" onChange={Handle_add_new_address} value="Office" name='address_type'
                                                                                className="input-field ml-4 placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                type="radio" required checked={add_new_address_form_data?.address_type === "Office"} /><span className='ml-2'>Office</span>
                                                                            <input placeholder="" onChange={Handle_add_new_address} value="Other" name='address_type'
                                                                                className="input-field ml-4 placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                                type="radio" required checked={add_new_address_form_data?.address_type === "Other"} /><span className='ml-2'>Other</span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="action-area">
                                                            <button type='submit'
                                                                className="w-[164px] inline-block text-center py-3 bg-[#9F2225] text-white text-sm">Save Address</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {/* <--------- Footer section's ----------> */}
            <Footer />
        </div>
    )
}

export default User_dashbaord_Add_New_Address